import React, {useEffect, useState} from 'react';
import classes from "./admin.module.css";
import Header from "./common/header/header";
import {addBalanceAPI, deleteConfigsAPI, getClientsAPI} from "./api";

const Clients = () => {
    const [data, setData] = useState([])
    const [data2, setData2] = useState([])
    const [configsDel, setConfigsDel] = useState([])
    const [openAll, setOpenAll] = useState(false)
    const [openAddBalance, setAddBalance] = useState(false)
    const [valueId, setValueId] = useState('')
    const [valueComment, setValueComment] = useState('Пополнение')
    const [valueSum, setValueSum] = useState('')

    const getClients = async ()=>{
        const res = await getClientsAPI()
        if(res){
            setData(res.clients)
            setData2(res.clients2)
        }
    }

    useEffect(()=>{
        getClients()
    },[])

    async function deleteConfigs(){
        const res = await deleteConfigsAPI(configsDel)
        await getClients()
        setConfigsDel([])
    }

    async function addBalance(){
        if(valueSum !== ''){
            await addBalanceAPI(valueId, valueComment, valueSum)
            setValueId('')
            setValueComment('Пополнение')
            setValueSum('')
            setAddBalance(false)
            await getClients()
        }
    }


    return (
        <div className={classes.block}>
            <Header/>
            <table className={classes.table} align="center" border="1">
                <tr>
                    <td>Всего пользователей</td>
                    <td>{data.length + data2.length}</td>
                </tr>
                <tr>
                    <td>Активных пользователей</td>
                    <td>{data.length}</td>
                </tr>
                <tr>
                    <td>Пользующиеся пользователи</td>
                    <td>{data.filter(client =>
                        client.configs.some(config => config.last_online)
                    ).length}</td>
                </tr>
                <tr>
                    <td>Оплачивающие пользователи</td>
                    <td>{data.filter(client => client.sum_payment > 0).length}</td>
                </tr>
                <tr>
                    <td>Ушедшие пользователи</td>
                    <td>{data2.filter(client => client.sum_payment > 0).length}</td>
                </tr>
            </table>
            <div className={classes.buttonBlock}>
                <button onClick={()=>setOpenAll(!openAll)}>{openAll ? 'Скрыть' : 'Показать все'}</button>
                <button onClick={deleteConfigs}>Удалить конфигурации</button>
            </div>
            <table className={classes.table} align="center" border="1">
                <tr>
                    <td className={classes.tableHeader}>ID</td>
                    <td className={classes.tableHeader}>Реферал</td>
                    <td className={classes.tableHeader}>⭐</td>
                    <td className={classes.tableHeader}>👫</td>
                    <td className={classes.tableHeader}>Логин</td>
                    <td className={classes.tableHeader}>Имя</td>
                    <td className={classes.tableHeader}>Баланс</td>
                    <td className={classes.tableHeader}>Реф Баланс</td>
                    <td className={classes.tableHeader}>💸</td>
                    <td className={classes.tableHeader}>Конфиг</td>
                    <td className={classes.tableHeader}>Онлайн</td>
                    <td className={classes.tableHeader}>Страна</td>
                </tr>
                {data.map(client=>
                    <>
                        {client.configs.map((config, number)=>
                            <>{
                                number === 0 ? <tr>
                                        <td rowSpan={client.configs.length}>{client.client.telegram_id}</td>
                                        <td rowSpan={client.configs.length}>{client.client.ref}</td>
                                        <td rowSpan={client.configs.length}>{client.client.subscription && 'П'}{client.client.premium && 'P'}</td>
                                        <td rowSpan={client.configs.length}>{client.ref}</td>
                                        <td rowSpan={client.configs.length}>
                                            {client.client.telegram_login && client.client.telegram_login !== 'None' && <a target="_blank" className={classes.tableLink} href={`https://t.me/${client.client.telegram_login}`}>@{client.client.telegram_login}</a>}
                                        </td>
                                        <td rowSpan={client.configs.length} onClick={()=>{setValueId(client.client.telegram_id); setAddBalance(true)}}>{client.client.telegram_name}</td>
                                        <td rowSpan={client.configs.length}>{client.client.balance}₽</td>
                                        <td rowSpan={client.configs.length}>{client.client.ref_balance}₽</td>
                                        <td rowSpan={client.configs.length}>{client.sum_payment}₽</td>
                                        <td style={configsDel.indexOf(config.name)!==-1?{background:'#AAA'}:{}}
                                            onClick={()=>{
                                                if(configsDel.indexOf(config.name)===-1){
                                                    setConfigsDel([...configsDel, config.name])
                                                }else{
                                                    setConfigsDel(configsDel.filter(item=>item!==config.name))
                                                }}}>{config.name}</td>
                                        <td>{config.last_online}</td>
                                        <td><a target="_blank" className={classes.tableLink} href={`http://${ config.server.ip }:${config.server.port}`}>{config.server.country}</a></td>
                                    </tr>:
                                    <tr>
                                        <td style={configsDel.indexOf(config.name)!==-1?{background:'#AAA'}:{}}
                                            onClick={()=>{
                                                if(configsDel.indexOf(config.name)===-1){
                                                    setConfigsDel([...configsDel, config.name])
                                                }else{
                                                    setConfigsDel(configsDel.filter(item=>item!==config.name))
                                                }}}>{config.name}</td>
                                        <td>{config.last_online}</td>
                                        <td>
                                            {config.server.port ? <a target="_blank" className={classes.tableLink} href={`http://${ config.server.ip }:${config.server.port}`}>{config.server.country}</a> :
                                                <a target="_blank" className={classes.tableLink} href={`https://${ config.server.ip }`}>{config.server.country}</a>}
                                        </td>
                                    </tr>
                            }
                            </>)}
                    </>

                )}
                {openAll && data2.map(client=>
                     <tr key={client.client.id}>
                        <td>{client.client.telegram_id}</td>
                        <td>{client.client.ref}</td>
                        <td>{client.client.subscription && 'П'}{client.client.premium && 'P'}</td>
                        <td>{client.ref}</td>
                        <td>
                            {client.client.telegram_login && client.client.telegram_login !== 'None' && <a target="_blank" className={classes.tableLink} href={`https://t.me/${client.client.telegram_login}`}>@{client.client.telegram_login}</a>}
                        </td>
                        <td onClick={()=>{setValueId(client.client.telegram_id); setAddBalance(true)}}>{client.client.telegram_name}</td>
                        <td>{client.client.balance}₽</td>
                        <td>{client.client.ref_balance}₽</td>
                        <td>{client.sum_payment}₽</td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                )}
            </table>
            {openAddBalance &&
                <div className={classes.fon} onClick={()=>setAddBalance(false)}>
                    <div className={classes.addBlock} onClick={e=>e.stopPropagation()}>
                        <div style={{textAlign:'center'}}>Пополнение</div>
                        <div>
                            <div>Пользователь</div>
                            <input name="user" id="user_input" value={valueId} onChange={e=>setValueId(e.target.value)}/>
                        </div>
                        <div>
                            <div>Коммент</div>
                            <input name="comment" id="comment_input" value={valueComment} onChange={e=>setValueComment(e.target.value)}/>
                        </div>
                        <div>
                            <div>Сумма</div>
                            <input type="number" name="summa" id="sum_input" value={valueSum} onChange={e=>setValueSum(e.target.value)}/>
                        </div>
                        <div className={classes.buttonBlock}>
                            <button onClick={addBalance}>Пополнить</button>
                            <button onClick={()=>setAddBalance(false)}>Отмена</button>
                        </div>
                    </div>
                </div>
            }
        </div>
    );
};

export default Clients;